
module.exports = {
	zh_TW: 0,
	en_US: 1,
	Unknown: 99
}